var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    id: "screenshot-2c349b1a-22ed-8030-8008-548196891924",
    viewBox: "0 0 16 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-2c349b1a-22ed-8030-8008-548196891924"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame-clip-2c349b1a-22ed-8030-8008-548196891924-render-1",
    className: "frame-clip frame-clip-def"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame-clip-2c349b1a-22ed-8030-8008-548196891924-render-1)",
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2c349b1a-22ed-8030-8008-548196891924"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-2c349b1a-22ed-8030-8008-548196891925",
    style: {
      opacity: 1
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2c349b1a-22ed-8030-8008-548196891925"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6669921875,14C3.9306640625,14,3.333984375,13.403076171875,3.333984375,12.666748046875L3.333984375,3.333251953125C3.333984375,2.596923828125,3.9306640625,2,4.6669921875,2L9.333984375,2L12.6669921875,5.333251953125L12.6669921875,12.666748046875C12.6669921875,13.403076171875,12.0703125,14,11.333984375,14L4.6669921875,14Z",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    id: "strokes-2a637677-2c15-8089-8008-5481b006a93b-2c349b1a-22ed-8030-8008-548196891925",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6669921875,14C3.9306640625,14,3.333984375,13.403076171875,3.333984375,12.666748046875L3.333984375,3.333251953125C3.333984375,2.596923828125,3.9306640625,2,4.6669921875,2L9.333984375,2L12.6669921875,5.333251953125L12.6669921875,12.666748046875C12.6669921875,13.403076171875,12.0703125,14,11.333984375,14L4.6669921875,14Z",
    style: {
      fill: "none",
      strokeWidth: 1.5,
      stroke: "rgb(76, 76, 76)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2c349b1a-22ed-8030-8008-548196891926",
    style: {
      opacity: 1
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2c349b1a-22ed-8030-8008-548196891926"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.666015625,2L8.666015625,6L12.666015625,6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-2a637677-2c15-8089-8008-5481b007ad75-2c349b1a-22ed-8030-8008-548196891926",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.666015625,2L8.666015625,6L12.666015625,6",
    style: {
      fill: "none",
      strokeWidth: 1.5,
      stroke: "rgb(76, 76, 76)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2c349b1a-22ed-8030-8008-548196891927",
    style: {
      opacity: 1
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2c349b1a-22ed-8030-8008-548196891927"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,8.666748046875L10,8.666748046875"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-2a637677-2c15-8089-8008-5481b007f375-2c349b1a-22ed-8030-8008-548196891927",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,8.666748046875L10,8.666748046875",
    style: {
      fill: "none",
      strokeWidth: 1.5,
      stroke: "rgb(76, 76, 76)",
      strokeOpacity: 1,
      strokeLinecap: "round"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-2c349b1a-22ed-8030-8008-548196891928",
    style: {
      opacity: 1
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-2c349b1a-22ed-8030-8008-548196891928"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,11.333251953125L10,11.333251953125"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-2a637677-2c15-8089-8008-5481b008408e-2c349b1a-22ed-8030-8008-548196891928",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,11.333251953125L10,11.333251953125",
    style: {
      fill: "none",
      strokeWidth: 1.5,
      stroke: "rgb(76, 76, 76)",
      strokeOpacity: 1,
      strokeLinecap: "round"
    }
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDocument);
export default __webpack_public_path__ + "static/media/File-Document.383e73c050e3d3c433102853a562c918.svg";
export { ForwardRef as ReactComponent };